import { Dealer } from '../../gql/graphql';

/**
 * Returns the dealer's display name, preferring the configured friendlyName
 * and falling back to storeName.
 */
export const getDealerFriendlyName = (dealer: Dealer | undefined): string | undefined => {
  return dealer?.friendlyName || dealer?.storeName;
};
